import { SetupDashboard, SetupModal } from '@40seas/frontend/libs/entities';
import { createContext } from 'react';

export const SetupDashboardContext = createContext<SetupDashboard | undefined>(undefined);

export const SetupModalContext = createContext<SetupModal | undefined>(undefined);
